import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import parse from 'html-react-parser'

const DocsTopicItem = (props) => {
  const { name, display_name, docs_data, expandedSubPanelName } = props
  const theme = useTheme()

  const [expandedSubPanel, setExpandedSubPanel] = useState('')

  const arrowStyle = {
    color: theme.palette.violetsAreBlue,
    fontSize: '36px',
  }

  const accordionStyle = {
    background: 'none',
    boxShadow: 'none',
  }

  const accordionSummaryStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
    fontWeight: '500',
    borderBottom: `${theme.palette.grayX11} 1px solid`,
  }

  const handleChangeExpandedSubPanel = (panel) => (event, newExpanded) => {
    setExpandedSubPanel(newExpanded ? panel : false)
  }

  useEffect(() => {
    setExpandedSubPanel((expandedSubPanelName && name === expandedSubPanelName) ? name : '')
  }, [name, expandedSubPanelName])

  return (
    <Accordion
      expanded={expandedSubPanel === name}
      onChange={handleChangeExpandedSubPanel(name)}
      sx={accordionStyle}
    >
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon sx={arrowStyle} />}
        sx={accordionSummaryStyle}
      >
        <Box>{display_name}</Box>     
      </AccordionSummary>
      <AccordionDetails>      
        <Box>{parse(docs_data)}</Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default DocsTopicItem